export const ARRAY_UTILS_SORT_ASC = 'ARRAY_UTILS_SORT_ASC';
export const ARRAY_UTILS_SORT_DESC = 'ARRAY_UTILS_SORT_DESC';

export const getOrderedByObjectStringProperty = (arr, propertyName, order) => {
  order = order === ARRAY_UTILS_SORT_DESC ? order : ARRAY_UTILS_SORT_ASC;
  const sort = (a, b) => {
    if (order === ARRAY_UTILS_SORT_ASC) {
      if (a[propertyName].toLowerCase() < b[propertyName].toLowerCase()) {
        return -1;
      } else {
        return 1;
      }
    } else {
      if (a[propertyName].toLowerCase() > b[propertyName].toLowerCase()) {
        return -1;
      } else {
        return 1;
      }
    }
  };
  return [...arr].sort(sort);
};

export const getNumbersOrderedAsc = (a, b) => {
  return a > b ? 1 : -1;
};

export const getNumbersOrderedDesc = (a, b) => {
  return a > b ? 1 : -1;
};

export const getNextValues = (currentValue, list) => {
  const year = parseInt(currentValue.split('-')[0]);
  const sem = parseInt(currentValue.split('-')[1]);
  const nextSem = sem === 1 ? 2 : 1;
  const nextYear = sem === 1 ? year : year + 1;
  const nextPeriod = `${nextYear}-${nextSem}`;
  const nextIndex = list.indexOf(nextPeriod);
  return nextIndex !== -1 ? [nextPeriod] : [];
};

export const indexOfObject = (arr, property, value) => {
  for (var i = 0, len = arr.length; i < len; i++) {
    if (arr[i][property] === value) return i;
  }
  return -1;
};
